import { NevoraCRM } from "./nevora/root/NevoraCRM";

/**
 * Punto de entrada de Nevora Sales.
 * Todo lo propio vive en src/nevora/; lo heredado de Atomic CRM, en src/components/.
 */
const App = () => <NevoraCRM />;

export default App;
